module.exports = __webpack_public_path__ + "img/macos-1-tw.0ae969e1.gif";